module.exports = __webpack_public_path__ + "static/media/Laura Spence.5d7c9845.png";